"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallOfTheSnowmanAbilityHandler = exports.CallOfTheSnowmanActorAbilityFactory = exports.CallOfTheSnowmanAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const ActorArgs_1 = require("../../core/actors/ActorArgs");
const ActorType_1 = require("../../core/actors/ActorType");
const enums_1 = require("../../core/enums");
const Record_1 = require("../../utils/Record");
class CallOfTheSnowmanAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.CallOfTheSnowman;
        this.__typeName = "CallOfTheSnowman";
    }
}
exports.CallOfTheSnowmanAbilityArgs = CallOfTheSnowmanAbilityArgs;
let CallOfTheSnowmanActorAbilityFactory = class CallOfTheSnowmanActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("CallOfTheSnowman", "Self", 4);
    }
};
CallOfTheSnowmanActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("CallOfTheSnowman")
], CallOfTheSnowmanActorAbilityFactory);
exports.CallOfTheSnowmanActorAbilityFactory = CallOfTheSnowmanActorAbilityFactory;
let CallOfTheSnowmanAbilityHandler = class CallOfTheSnowmanAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const invoker = container.getActor(ability.invokerId);
        container.unsummonAllSummonedCompanions(sequence, ability.invokerId);
        const snowmanArgs = new ActorArgs_1.NpcActorArgs(invoker.faction, ActorType_1.ActorType.Snowman, invoker.level, 
        // attributes...
        Object.entries(invoker.maxAttributeValues).reduce((pet, [key, value]) => {
            let multiplier = 1;
            switch (+key) {
                case enums_1.AttributeType.Focus:
                    value = (0, Record_1.getValueOrDefault)(invoker.maxAttributeValues, enums_1.AttributeType.Power, 0);
                    break;
            }
            pet[key] = Math.round(value * multiplier);
            return pet;
        }, {}), {
            [enums_1.AbilitySlot.Ability1]: Registries_1.ActorAbilities.getItem("IcicleStorm").mk(),
        })
            .withPlayerId(invoker.playerId);
        container.applyAbilityAnimation({
            sequence,
            animatedId: ability.invokerId,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            onAnimated: sequence => {
                container.summonCompanion(sequence, ability.invokerId, snowmanArgs);
            }
        });
    }
};
CallOfTheSnowmanAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.CallOfTheSnowman)
], CallOfTheSnowmanAbilityHandler);
exports.CallOfTheSnowmanAbilityHandler = CallOfTheSnowmanAbilityHandler;
